import type { FieldComponentProps } from "./field-shell";

export function SectionHeadingField({ field }: FieldComponentProps) {
  if (field.kind !== "section_heading") return null;
  return (
    <div className="border-b border-border/70 pb-2 pt-4 first:pt-0">
      <h2 className="font-display text-lg font-semibold tracking-tight text-foreground">
        {field.label}
      </h2>
      {field.helpText ? (
        <p className="mt-1 text-sm text-muted-foreground">{field.helpText}</p>
      ) : null}
    </div>
  );
}
